import { Route, Routes } from 'react-router-dom';
import { AppProviders } from './AppProviders';
import { MainLayout } from '@/components/layout/MainLayout';
import { DuMonitorDashboardPage } from '@/features/dashboard';
import { EventDetailsPage } from '@/features/event-details';
import { SyncJobsDashboardPage } from '@/features/sync-jobs';

export function App() {
  return (
    <AppProviders>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<DuMonitorDashboardPage />} />
          <Route path="/dashboard" element={<DuMonitorDashboardPage />} />
          <Route path="/dashboard-old" element={<SyncJobsDashboardPage />} />
          <Route
            path="/event-details/:eventCode/:accountCode"
            element={<EventDetailsPage />}
          />
        </Route>
      </Routes>
    </AppProviders>
  );
}
